(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6042],{

/***/ 19844:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dang-ky",
      function () {
        return __webpack_require__(18465);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73946);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var useCountdownTimer = function(durationInSeconds) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useSetState */ .v)({
        durationLeftInSeconds: null,
        isExpired: false,
        start: false
    }), 2), ref1 = ref[0], isExpired = ref1.isExpired, start = ref1.start, durationLeftInSeconds = ref1.durationLeftInSeconds, setState = ref[1];
    var startCountdown = function() {
        reset();
        setState({
            start: true
        });
    };
    var reset = function() {
        setState({
            durationLeftInSeconds: durationInSeconds,
            isExpired: false,
            start: false
        });
    };
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        return setState({
            durationLeftInSeconds: durationInSeconds
        });
    }, [
        durationInSeconds
    ]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (!start) return;
        var intervalId = setInterval(function() {
            setState({
                durationLeftInSeconds: durationLeftInSeconds - 1
            });
        }, 1000);
        if (durationLeftInSeconds <= 0) {
            setState({
                isExpired: true
            });
            clearInterval(intervalId);
        }
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        durationLeftInSeconds,
        start
    ]);
    return {
        isExpired: isExpired,
        durationLeftInSeconds: durationLeftInSeconds,
        startCountdown: startCountdown
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCountdownTimer);


/***/ }),

/***/ 25217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OtpForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useCountdownTimer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(704);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26679);
/* harmony import */ var _setup_locale_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59963);
/* harmony import */ var _setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97744);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80061);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88393);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67841);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66137);
/* harmony import */ var _mantine_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);












function OtpForm(param) {
    var authOtp = param.authOtp, resend = param.resend, callback = param.callback;
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var getLabel = (0,_setup_locale_provider__WEBPACK_IMPORTED_MODULE_4__/* .useLocalContext */ .u)().getLabel;
    var ref = (0,_hooks_useCountdownTimer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(120), durationLeftInSeconds = ref.durationLeftInSeconds, startCountdown = ref.startCountdown, isExpired = ref.isExpired;
    // startCountdown();
    react__WEBPACK_IMPORTED_MODULE_6__.useEffect(function() {
        startCountdown();
    }, []);
    var form = (0,_mantine_form__WEBPACK_IMPORTED_MODULE_7__/* .useForm */ .c)({
        initialValues: {
            otp: ""
        },
        validate: {
            otp: function(value) {
                return value.length > 0 ? null : getLabel("Vui l\xf2ng nhập m\xe3 x\xe1c thực");
            }
        }
    });
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var rs_authOtp;
            return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return authOtp(form.values.otp);
                    case 3:
                        rs_authOtp = _ctx.sent;
                        if (!rs_authOtp.status) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", callback());
                    case 6:
                        return _ctx.abrupt("return", form.setErrors({
                            otp: "M\xe3 x\xe1c thực kh\xf4ng hợp lệ"
                        }));
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("Error handleSubmit OtpForm => ", _ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var rs_resend;
            return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isExpired) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", undefined);
                    case 2:
                        _ctx.next = 4;
                        return resend();
                    case 4:
                        rs_resend = _ctx.sent;
                        if (rs_resend.status) {
                            (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_5__/* .appAlert */ .t)({
                                type: "success",
                                message: rs_resend.message
                            });
                            startCountdown();
                        } else {
                            (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_5__/* .appAlert */ .t)({
                                type: "error",
                                message: rs_resend.message
                            });
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
            onSubmit: form.onSubmit(handleSubmit),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                    label: trans === null || trans === void 0 ? void 0 : trans.otpFrom.title,
                    withAsterisk: true,
                    placeholder: trans === null || trans === void 0 ? void 0 : trans.otpFrom.placeholder
                }, form.getInputProps("otp")), {
                    sx: {
                        width: "calc(100% - 18px)"
                    },
                    styles: {
                        input: {
                            borderRight: "none",
                            borderTopRightRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    },
                    rightSection: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Tooltip */ .u, {
                        label: trans === null || trans === void 0 ? void 0 : trans.otpFrom.resend,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                            variant: "outline",
                            color: isExpired ? "dark" : "gray",
                            radius: "md",
                            styles: {
                                root: {
                                    borderTopLeftRadius: 0,
                                    borderEndStartRadius: 0
                                },
                                input: {
                                    letterSpacing: "2px"
                                }
                            },
                            // disabled={!isExpired}
                            onClick: function() {
                                return handleResend();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                weight: "normal",
                                children: isExpired ? trans === null || trans === void 0 ? void 0 : trans.otpFrom.resend : "".concat(Math.floor(durationLeftInSeconds / 60), " : ").concat(durationLeftInSeconds % 60 < 10 ? "0".concat(durationLeftInSeconds % 60) : durationLeftInSeconds % 60)
                            })
                        })
                    })
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Group */ .Z, {
                    position: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                        type: "submit",
                        mt: "sm",
                        fullWidth: true,
                        variant: "outline",
                        color: "dark",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                            weight: "500",
                            transform: "uppercase",
                            children: trans === null || trans === void 0 ? void 0 : trans.otpFrom.submit
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 18465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DangKy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(828);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6559);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35985);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26679);
/* harmony import */ var _setup_locale_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59963);
/* harmony import */ var _setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97744);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44061);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64523);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(21017);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9094);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(19236);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(80061);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(73193);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(38078);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(67841);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(38090);
/* harmony import */ var _mantine_form__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98903);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var _components_OtpForm__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25217);
/* eslint-disable import/extensions */ /* eslint-disable react/jsx-curly-brace-presence */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable no-use-before-define */ /* eslint-disable no-else-return */ /* eslint-disable prefer-const */ /* eslint-disable camelcase */ /* eslint-disable no-nested-ternary */ 



















var ReCAPTCHA = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return __webpack_require__.e(/* import() */ 6140).then(__webpack_require__.bind(__webpack_require__, 6140));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6140)
            ];
        }
    }
});
function DangKy() {
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var getLabel = (0,_setup_locale_provider__WEBPACK_IMPORTED_MODULE_5__/* .useLocalContext */ .u)().getLabel;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var ref = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), signup = ref.signup, sendOtp = ref.sendOtp, authOtp = ref.authOtp, token = ref.token;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_11__.useState(false), 2), opened = ref1[0], setOpened = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_11__.useState(false), 2), modalTitle = ref2[0], setModalTitle = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_11__.useState(false), 2), isReCaptchaNeeded = ref3[0], setIsReCaptchaNeeded = ref3[1];
    react__WEBPACK_IMPORTED_MODULE_11__.useEffect(function() {
        var hasToken = Boolean((0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_14__/* .getFromStorage */ .L2)("token"));
        if (hasToken) {
            router.push("/");
        }
    }, []);
    react__WEBPACK_IMPORTED_MODULE_11__.useEffect(function() {
        if (!token) return undefined;
        (0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_14__/* .setToStorage */ .Pp)("token", token);
        // localStorage.setItem("token", token);
        window.location.href = "/";
        return null;
    }, [
        token
    ]);
    var resend = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var rs_otpInfo;
            return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return sendOtp(form.values.email);
                    case 3:
                        rs_otpInfo = _ctx.sent;
                        if (!rs_otpInfo.status) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: true,
                            message: "".concat(trans === null || trans === void 0 ? void 0 : trans.register.alert.sendOtpSuccess).concat(form.values.email)
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            status: false,
                            message: trans === null || trans === void 0 ? void 0 : trans.register.alert.sendOtpFailed
                        });
                    case 9:
                        _ctx.next = 15;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("Error handleSubmit => ", _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        return _ctx.abrupt("return", {
                            status: false,
                            message: trans === null || trans === void 0 ? void 0 : trans.register.alert.sendOtpFailed
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function resend() {
            return _ref.apply(this, arguments);
        };
    }();
    var form = (0,_mantine_form__WEBPACK_IMPORTED_MODULE_16__/* .useForm */ .c)({
        initialValues: {
            email: "",
            name: "",
            password: "",
            rePassword: "",
            termsOfService: false
        },
        validate: {
            email: function(value) {
                return /^\S+@\S+$/.test(value) || /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(value) ? null : trans === null || trans === void 0 ? void 0 : trans.register.validate.email;
            },
            name: function(value) {
                return value.length > 0 ? null : trans === null || trans === void 0 ? void 0 : trans.register.validate.blankPassword;
            },
            password: function(value) {
                return value.length > 0 ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*#?&]{6,}$/.test(value) ? null : trans === null || trans === void 0 ? void 0 : trans.register.validate.password : trans === null || trans === void 0 ? void 0 : trans.register.validate.blankPassword;
            },
            rePassword: function(value, values) {
                return value.length > 0 ? value !== values.password ? trans === null || trans === void 0 ? void 0 : trans.register.validate.password1 : null : trans === null || trans === void 0 ? void 0 : trans.register.validate.blankPassword;
            }
        }
    });
    var handleError = function() {};
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var rs_signup, rs_otpInfo;
            return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (form.values.termsOfService) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", form.setFieldError("termsOfService", true));
                    case 2:
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return signup(form.values);
                    case 5:
                        rs_signup = _ctx.sent;
                        if (!rs_signup.status) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 9;
                        return sendOtp(form.values.email);
                    case 9:
                        rs_otpInfo = _ctx.sent;
                        if (rs_otpInfo.status) {
                            setModalTitle(rs_otpInfo.message);
                            setOpened(true);
                        }
                        _ctx.next = 14;
                        break;
                    case 13:
                        {
                            form.setErrors({
                                email: rs_signup.message
                            });
                        // console.log("a", form.values.email);
                        }
                    case 14:
                        _ctx.next = 20;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](2);
                        form.setErrors({
                            email: _ctx.t0.message || _ctx.t0.error || _ctx.t0
                        });
                        console.log("Error handleSubmit => ", _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    16
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var callback = function() {
        setOpened(false);
        (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_6__/* .appAlert */ .t)({
            type: "success",
            message: trans === null || trans === void 0 ? void 0 : trans.register.alert.success
        });
        router.replace("/dang-nhap");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .x, {
        component: "div",
        py: "lg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                    children: trans === null || trans === void 0 ? void 0 : trans.register.seoTitle
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                size: "sm",
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_18__/* .Card */ .Z, {
                        shadow: "sm",
                        p: "lg",
                        radius: "md",
                        withBorder: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Center */ .M, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Title */ .D, {
                                    order: 3,
                                    children: trans === null || trans === void 0 ? void 0 : trans.register.title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                onSubmit: form.onSubmit(handleSubmit, handleError),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_21__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                        withAsterisk: true,
                                        label: trans === null || trans === void 0 ? void 0 : trans.register.userName,
                                        labelProps: {
                                            style: {
                                                color: "#000"
                                            }
                                        }
                                    }, form.getInputProps("email")), {
                                        placeholder: trans === null || trans === void 0 ? void 0 : trans.register.placeholder.userName,
                                        onFocus: function() {
                                            setIsReCaptchaNeeded(true);
                                        },
                                        mb: 5
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_21__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                        withAsterisk: true,
                                        label: trans === null || trans === void 0 ? void 0 : trans.register.fullName,
                                        labelProps: {
                                            style: {
                                                color: "#000"
                                            }
                                        }
                                    }, form.getInputProps("name")), {
                                        placeholder: trans === null || trans === void 0 ? void 0 : trans.register.placeholder.fullName,
                                        mb: 5
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_24__/* .PasswordInput */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                        withAsterisk: true,
                                        label: trans === null || trans === void 0 ? void 0 : trans.register.password,
                                        labelProps: {
                                            style: {
                                                color: "#000"
                                            }
                                        }
                                    }, form.getInputProps("password")), {
                                        placeholder: trans === null || trans === void 0 ? void 0 : trans.register.placeholder.password,
                                        mb: 5
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_24__/* .PasswordInput */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                        withAsterisk: true,
                                        label: trans === null || trans === void 0 ? void 0 : trans.register.rePassword,
                                        labelProps: {
                                            style: {
                                                color: "#000"
                                            }
                                        }
                                    }, form.getInputProps("rePassword")), {
                                        placeholder: trans === null || trans === void 0 ? void 0 : trans.register.placeholder.rePassword,
                                        mb: 5
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_25__/* .Checkbox */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .x, {
                                            sx: {
                                                color: form.errors.termsOfService ? "red" : "#000"
                                            },
                                            children: [
                                                trans === null || trans === void 0 ? void 0 : trans.register.role,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                    scroll: false,
                                                    href: trans === null || trans === void 0 ? void 0 : trans.register.linkPolicy,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        target: "_blank",
                                                        "aria-label": "Terms of condition",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("u", {
                                                            children: trans === null || trans === void 0 ? void 0 : trans.register.policy
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }, form.getInputProps("termsOfService", {
                                        type: "checkbox"
                                    })), {
                                        mt: "sm"
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_26__/* .Group */ .Z, {
                                        position: "center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_27__/* .Button */ .z, {
                                            type: "submit",
                                            mt: "sm",
                                            fullWidth: true,
                                            variant: "outline",
                                            color: "dark",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_28__/* .Text */ .x, {
                                                weight: "500",
                                                transform: "uppercase",
                                                children: trans === null || trans === void 0 ? void 0 : trans.register.submit
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Center */ .M, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .x, {
                                            sx: {
                                                display: "flex"
                                            },
                                            mt: 10,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_28__/* .Text */ .x, {
                                                    size: "sm",
                                                    mr: 4,
                                                    children: trans === null || trans === void 0 ? void 0 : trans.register.swap
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                    scroll: false,
                                                    href: "/dang-nhap",
                                                    replace: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_28__/* .Text */ .x, {
                                                            weight: "700",
                                                            transform: "uppercase",
                                                            size: "sm",
                                                            children: trans === null || trans === void 0 ? void 0 : trans.register.login
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_29__/* .Modal */ .u, {
                        opened: opened,
                        onClose: function() {
                            return setOpened(false);
                        },
                        title: getLabel(modalTitle),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_OtpForm__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            authOtp: authOtp,
                            resend: resend,
                            callback: callback
                        })
                    })
                ]
            }),
            isReCaptchaNeeded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReCAPTCHA, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1910,8795,9774,2888,179], function() { return __webpack_exec__(19844); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);